<template>
  <v-content :class="contentClass">
    <v-container fluid>
      <v-row align="center" justify="center">
        <router-view />
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
export default {
  name: "Main",
  computed: {
    contentClass() {
      return this.$route.path === '/dashboard-finance' ? 'bg-gray-100' : '';
    }
  }
};
</script>
